module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_referidos.e456c2a3.svg";